import 'react-native-url-polyfill/auto';

import AsyncStorage from '@react-native-async-storage/async-storage';
import { createClient } from '@supabase/supabase-js';
import { AppState, Platform } from 'react-native';

import type { Database } from '@/lib/database.types';

const supabaseUrl = process.env.EXPO_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // Καθαρό μήνυμα κατά την ανάπτυξη αν λείπει το .env.
  throw new Error(
    'Λείπουν τα Supabase credentials. Αντίγραψε το .env.example σε .env και ' +
      'συμπλήρωσε EXPO_PUBLIC_SUPABASE_URL και EXPO_PUBLIC_SUPABASE_ANON_KEY.',
  );
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Στο web δεν υπάρχει AsyncStorage· ο client πέφτει στο localStorage.
    storage: Platform.OS === 'web' ? undefined : AsyncStorage,
    autoRefreshToken: true,
    persistSession: true,
    // Χειριζόμαστε το deep-link recovery χειροκίνητα (AuthContext), όχι auto.
    detectSessionInUrl: false,
    // Implicit flow → τα tokens επαναφοράς έρχονται στο fragment (#) του link,
    // ώστε να τα διαβάσουμε χειροκίνητα και στο native.
    flowType: 'implicit',
  },
});

// Σε React Native το auto-refresh σταματά όταν η εφαρμογή πάει background.
// Το AppState listener το ξαναεκκινεί μόλις επιστρέψει στο foreground,
// ώστε να ανανεώνεται το JWT και να μην αποτυγχάνουν τα requests μετά από αδράνεια.
if (Platform.OS !== 'web') {
  AppState.addEventListener('change', (state) => {
    if (state === 'active') {
      supabase.auth.startAutoRefresh();
      // Άμεση ανανέωση token — startAutoRefresh μόνο ρυθμίζει timer για μέλλον
      void supabase.auth.refreshSession();
    } else {
      supabase.auth.stopAutoRefresh();
    }
  });
}
